import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getToken } from "../../lib/api";
import { getOnboarding } from "../../lib/onboardingApi";

function resolveNextRoute(onboarding) {
  if (!onboarding) return "/merchant/signup";

  if (!onboarding.merchant_profile_completed) {
    return "/merchant/signup";
  }

  if (!onboarding.boutique_details_completed) {
    return "/merchant/onboarding/boutique-details";
  }

  return "/merchant/dashboard/catalog";
}

export default function OnboardingGuard({ children }) {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [nextRoute, setNextRoute] = useState("/merchant/signup");
  const [allowed, setAllowed] = useState(false);

  const params = new URLSearchParams(location.search);
  const devBypass = params.get("dev") === "1";

  useEffect(() => {
    let cancelled = false;

    async function run() {
      if (devBypass) {
        if (!cancelled) {
          setAllowed(true);
          setLoading(false);
        }
        return;
      }

      if (!getToken()) {
        if (!cancelled) {
          setNextRoute("/merchant/login");
          setAllowed(false);
          setLoading(false);
        }
        return;
      }

      try {
        const onboarding = await getOnboarding();
        const resolved = resolveNextRoute(onboarding);

        const order = [
          "/merchant/signup",
          "/merchant/onboarding/boutique-details",
        ];

        const currentIndex = order.indexOf(location.pathname);
        const nextIndex = order.indexOf(resolved);

        const isAllowed =
          location.pathname === resolved ||
          (currentIndex !== -1 && nextIndex !== -1 && currentIndex <= nextIndex);

        if (!cancelled) {
          setNextRoute(resolved);
          setAllowed(isAllowed);
        }
      } catch (err) {
        console.error("Failed to resolve onboarding state", err);

        if (!cancelled) {
          setNextRoute("/merchant/signup");
          setAllowed(false);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    run();

    return () => {
      cancelled = true;
    };
  }, [location.pathname, devBypass]);

  if (loading) return null;

  if (!allowed && !devBypass) {
    return <Navigate to={nextRoute} replace />;
  }

  return children;
}